import "./App.scss";
import React from "react";
import {
  getArea,
  convertTo12Hr,
  getAmPm,
  getTimeStamp
} from "./components/functions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faXmark } from "@fortawesome/pro-solid-svg-icons";

const didntMake = [
  "Qty too high",
  "Qty too few to make it worthwhile",
  "Bakery is quiet",
  "Run out of ingredients",
  "Issue with ingredients",
  "Ingredients not delivered",
  "I'm too busy",
  "Went on a break",
  "Was busy ordering ingredients",
  "I'm confused",
  "Other"
];

const outsideWave = [
  "I missed the previous wave",
  "Sold out early",
  "Bakery is busy",
  "I'm confused",
  "Other"
];

const madeBut = [
  "Qty too high",
  "Qty too low",
  "Qty too few, felt a waste of time",
  "Bakery is quiet",
  "Bakery is busy",
  "I'm confused",
  "Other"
];

interface FeedbackProps {
  storeName: string | null;
  isFOH: boolean;
  productName: string | null;
  productSKU: string | null;
  plannerHour: string | null;
  quantity: number | null;
  made: number | null;
  handleHideFeedback: () => void;
  handleClearFeedback: () => void;
  showFeedback: boolean;
}

const Feedback: React.FC<FeedbackProps> = ({
  storeName,
  isFOH,
  productName,
  productSKU,
  plannerHour,
  quantity,
  made,
  handleHideFeedback,
  handleClearFeedback,
  showFeedback
}) => {
  const submitFeedback = (reason: string) => {
    window.dataLayer.push({
      event: "Feedback",
      bakery: storeName,
      bakery_area: getArea(isFOH),
      product: productName ?? "",
      productSKU: productSKU ?? "",
      time: getTimeStamp(),
      plannerHour: plannerHour ?? "",
      quantity: quantity ? quantity.toString() : "0",
      made: made ? made.toString() : "0",
      value: reason
    });
    handleClearFeedback();
    setTimeout(() => {
      handleHideFeedback();
    }, 1000);
  };

  return (
    <div className={`feedback hlpr-flexbox ${showFeedback ? "active" : null}`}>
      <div className="feedback__content">
        <div className="hlpr-relative">
          <div className="metric-nav">
            <FontAwesomeIcon
              icon={faXmark as IconProp}
              className="metric-nav__close"
              onClick={handleHideFeedback}
            />
          </div>
          <h2 className="h2 metric-title">
            {productName ? (
              <>
                Feedback on {quantity} <small className="color-red">x</small>{" "}
                {productName}
                {plannerHour == "Totals" ? (
                  " for production today"
                ) : plannerHour ? (
                  <>
                    {" "}
                    at {convertTo12Hr(parseInt(plannerHour))}
                    <small className="color-red">
                      {getAmPm(parseInt(plannerHour))}
                    </small>
                  </>
                ) : null}
              </>
            ) : (
              "Thank you, feedback submitted"
            )}
          </h2>
          <div className="feedback__sections">
            <p>I didn't produce because:</p>
            <div className="feedback__options hlpr-flexbox">
              {didntMake.map((reason) => (
                <a
                  key={reason}
                  className="feedback__option feedback__option--didnt-make"
                  onClick={() => {
                    submitFeedback(`Didn't make - ${reason}`);
                  }}
                >
                  {reason}
                </a>
              ))}
            </div>
          </div>
          <div className="feedback__sections">
            <p>I produced outside of the suggested wave because:</p>
            <div className="feedback__options hlpr-flexbox">
              {outsideWave.map((reason) => (
                <a
                  key={reason}
                  className="feedback__option feedback__option--outside-wave"
                  onClick={() => {
                    submitFeedback(`Made outside wave - ${reason}`);
                  }}
                >
                  {reason}
                </a>
              ))}
            </div>
          </div>

          <div className="feedback__sections">
            <p>I produced as suggested but:</p>
            <div className="feedback__options hlpr-flexbox">
              {madeBut.map((reason) => (
                <a
                  key={reason}
                  className="feedback__option feedback__option--made-but"
                  onClick={() => {
                    submitFeedback(`Made but - ${reason}`);
                  }}
                >
                  {reason}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Feedback;
